import { Injectable } from '@angular/core';
import { Router } from '@angular/router';


@Injectable()
export class AuthService {
    private SSkey = 'jwt';
    private SSdata = 'dataUser';
    private SSautenticado = 'autenticacion';

    /**
     * Ruta pública a la que se expulsa al usuario cuando la sesión deja de ser válida.
     * Es la misma a la que redirige la raíz del sitio y tiene el botón "Ingresar".
     */
    readonly rutaSalida = '/start-window';

    /** Margen (ms) para no dar por vigente un token que está a punto de expirar. */
    private readonly margenExpiracion = 5000;

    /** Cierra la sesión sola en cuanto el token caduca, aunque el usuario no toque nada. */
    private temporizadorExpiracion: any = null;

    /** Evita que varias respuestas 402 seguidas disparen varias redirecciones. */
    private cerrandoSesion = false;

    constructor(private router: Router) {
        this.detectAuth();
        this.programarCierrePorExpiracion();
    }

    setAuth(data: any) {
        console.log('token guardado', data);
        if (!data) {
            this.deleteAuth();
            return;
        }
        localStorage.setItem(this.SSkey, data);
        this.detectAuth();
        this.programarCierrePorExpiracion();
    }

    setData(data: any) {
        console.log('data guardada', data);
        localStorage.setItem(this.SSdata, JSON.stringify(data));
        // this.detectAuth();
    }

    getToken() {
        return localStorage.getItem(this.SSkey);
    }

    getData() {
        const data = localStorage.getItem(this.SSdata);
        if (!data) {
            return null;
        }

        try {
            return JSON.parse(data);
        } catch (error) {
            return null;
        }
    }

    isAuthenticated() {
        const token = this.getToken();
        const data = this.getData();

        if (!token || !data || !data.tipoUsuario) {
            return false;
        }

        return !this.isTokenExpired();
    }

    /**
     * Lee el payload del JWT sin verificar la firma (eso solo puede hacerlo el backend).
     * Sirve únicamente para saber si ya caducó y ahorrarnos la llamada.
     */
    getTokenPayload(): any {
        const token = this.getToken();

        if (!token) {
            return null;
        }

        const partes = token.split('.');

        if (partes.length !== 3) {
            return null;
        }

        try {
            let base64 = partes[1].replace(/-/g, '+').replace(/_/g, '/');

            while (base64.length % 4 !== 0) {
                base64 = base64 + '=';
            }

            const crudo = atob(base64);
            let utf8 = '';

            for (let i = 0; i < crudo.length; i++) {
                utf8 = utf8 + '%' + ('00' + crudo.charCodeAt(i).toString(16)).slice(-2);
            }

            return JSON.parse(decodeURIComponent(utf8));
        } catch (error) {
            // Token ilegible: lo tratamos como inválido en isTokenExpired().
            return null;
        }
    }

    isTokenExpired(): boolean {
        const payload = this.getTokenPayload();

        if (!payload) {
            // Sin token o con un token que no se puede leer: no sirve.
            return true;
        }

        if (!payload.exp) {
            // Token sin fecha de expiración: no hay nada que comprobar aquí,
            // será el backend quien lo rechace si no lo acepta.
            return false;
        }

        return Date.now() >= (payload.exp * 1000) - this.margenExpiracion;
    }

    /** Milisegundos que le quedan al token. 0 si ya caducó o no se puede saber. */
    tiempoRestante(): number {
        const payload = this.getTokenPayload();

        if (!payload || !payload.exp) {
            return 0;
        }

        const restante = (payload.exp * 1000) - Date.now();

        return restante > 0 ? restante : 0;
    }

    /**
     * Cierra la sesión y devuelve al usuario a la portada para que vuelva a entrar.
     * `motivo` solo se usa para dejar rastro en consola.
     */
    logout(motivo: string = 'sesion finalizada') {
        if (this.cerrandoSesion) {
            return;
        }

        this.cerrandoSesion = true;
        console.log('cierre de sesion:', motivo);

        this.deleteAuth();

        this.router.navigate([this.rutaSalida]).then(
            () => { this.cerrandoSesion = false; },
            () => { this.cerrandoSesion = false; }
        );
    }

    deleteAuth() {
        this.cancelarTemporizador();
        localStorage.setItem(this.SSautenticado, 'error');
        localStorage.removeItem(this.SSkey);
        localStorage.removeItem(this.SSdata);
    }

    detectAuth() {
        if (!localStorage.getItem(this.SSkey)) {
            localStorage.setItem(this.SSautenticado, 'error');
            // this.appService.usuario.autenticado = false;
            console.log('error');
        } else {
            localStorage.setItem(this.SSautenticado, 'OK');
            // this.appService.usuario.autenticado = true;
            console.log('autenticacion ok');
        }

    }

    /**
     * Programa el cierre de sesión para el instante exacto en que caduca el token.
     * Cubre el caso de tener la pestaña abierta sin hacer ninguna petición.
     */
    private programarCierrePorExpiracion() {
        this.cancelarTemporizador();

        const restante = this.tiempoRestante();

        if (restante <= 0) {
            // Ya caducado (o token sin exp): lo resuelven el guard y el interceptor.
            return;
        }

        if (restante > 2147483647) {
            // setTimeout desborda pasados ~24,8 días y dispararía de inmediato.
            return;
        }

        this.temporizadorExpiracion = setTimeout(
            () => { this.logout('el token expiro'); },
            restante
        );
    }

    private cancelarTemporizador() {
        if (this.temporizadorExpiracion) {
            clearTimeout(this.temporizadorExpiracion);
            this.temporizadorExpiracion = null;
        }
    }
}
